export var DescriptionPositions;
(function (DescriptionPositions) {
    DescriptionPositions["top"] = "top";
    DescriptionPositions["down"] = "down";
    DescriptionPositions["left"] = "left";
    DescriptionPositions["right"] = "right";
})(DescriptionPositions || (DescriptionPositions = {}));
export var DescriptionAlign;
(function (DescriptionAlign) {
    DescriptionAlign["middle"] = "middle";
    DescriptionAlign["left"] = "left";
    DescriptionAlign["right"] = "right";
})(DescriptionAlign || (DescriptionAlign = {}));
//# sourceMappingURL=constants.js.map